module.exports = __webpack_public_path__ + "images/car_alarm_1.3e044beca9f7bf8fab04daed70eb7b11.svg";